module.exports = {
    productDetailAvailability: {
        notRanged: 'Sorry, temporarily unavailable.',
        outOfStock: 'This item is currently out of stock at the store that services your location.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/product-detail-availability.js